import React from "react";
import { Modal } from "antd";
import { ReactNode } from "react";
import "../../../assets/styles/components/confirm-modal.css";
import { LegacyButtonType } from "antd/lib/button/button";

type Props = {
  onOk: () => void;
  onCancel: () => void;
  title: string;
  description: string | ReactNode;
  description2?: ReactNode;
  canceText: string;
  okText: string;
  icon?: ReactNode;
  width?: number;
  height?: number;
  className?: string;
  okType?: LegacyButtonType;
};

const ConfirmModalAsync = ({
  onOk,
  onCancel,
  title,
  description,
  canceText,
  okText,
  icon,
  width,
  height,
  className,
  description2,
  okType,
}: Props) => {
  Modal.confirm({
    width: width ?? 479,
    style: {
      height: height ?? 272,
    },
    centered: true,
    className:
      className ??
      "confirm__modal confirm__modal-confirm confirm__modal-purple-oke",
    title,
    icon,
    content: (
      <>
        {typeof description === "string" ? (
          <div
            style={
              description.includes("\n")
                ? { whiteSpace: "pre-line" }
                : undefined
            }
          >
            {description}
          </div>
        ) : (
          description
        )}
        {description2 && <div>{description2}</div>}
      </>
    ),
    okText: okText,
    okType: "danger",
    closable: true,
    cancelText: canceText,
    onOk: async () => {
      if (onOk) {
        await onOk();
      }
    },
    onCancel: () => {
      if (onCancel) {
        onCancel();
      }
    },
  });
};

export default ConfirmModalAsync;
